(() => {
  const breakpoint = window.matchMedia('(min-width: 990px)');

  const placeReview = () => {
    const review = document.querySelector('[data-mys-product-review]');
    const anchor = document.querySelector('[data-mys-product-review-anchor]');
    const target = document.querySelector('[data-mys-product-reviews-target]');

    if (!review || !anchor) return;

    if (breakpoint.matches && target) {
      target.appendChild(review);
    } else {
      anchor.insertAdjacentElement('afterend', review);
    }
  };

  document.addEventListener('DOMContentLoaded', placeReview);
  window.addEventListener('load', placeReview);

  if (typeof breakpoint.addEventListener === 'function') {
    breakpoint.addEventListener('change', placeReview);
  } else if (typeof breakpoint.addListener === 'function') {
    breakpoint.addListener(placeReview);
  }
})();